import EventBroker from "../../scripts/eventBroker";

const formBus = new EventBroker()

export {formBus}